import { v4 as uuid } from 'uuid';
import { Envs } from './service/types';

interface GlobalStore {
  orgCode: string;
  pid: string;
  authorization: string;
  salt: string;
  sessionId: string;
  app_code?: string;
  sellerId?: string;
  oppId?: string;
  env?: Envs;
  main_base_url?: string;
}

const globalStore: GlobalStore = {
  orgCode: '',
  pid: '',
  authorization: '',
  salt: '',
  sessionId: uuid(),
  app_code: '',
  sellerId: '',
  oppId: '',
  env: Envs.PRO,
  main_base_url: '',
};

export default globalStore;
